import { eventBus } from "@/event-bus";

export default {
  methods: {
    confirm (message, action) {
      eventBus.$emit("confirm-action", message, action);
    }
  }
}